var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuitecaseSmall = function SvgSuitecaseSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19348 8.7525C6.91734 8.7525 6.69348 8.97636 6.69348 9.2525C6.69348 9.52864 6.91734 9.7525 7.19348 9.7525V8.7525ZM8.80653 9.7525C9.08268 9.7525 9.30653 9.52864 9.30653 9.2525C9.30653 8.97636 9.08268 8.7525 8.80653 8.7525V9.7525ZM7.19348 9.7525H8.80653V8.7525H7.19348V9.7525Z",
    fill: "#ED7E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37062 5.17169V5.17169C3.70247 5.17169 3.16083 5.71333 3.16083 6.38148V9.99997C3.16083 11.1045 4.05626 12 5.16083 12H10.8391C11.9437 12 12.8391 11.1045 12.8391 9.99997V6.38148C12.8391 5.71333 12.2975 5.17169 11.6294 5.17169V5.17169",
    stroke: "#2F353B",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 7.33331L12.6666 7.33331",
    stroke: "#2F353B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 5.83838C5.875 6.11453 6.09886 6.33838 6.375 6.33838C6.65114 6.33838 6.875 6.11453 6.875 5.83838H5.875ZM9.125 5.83838C9.125 6.11453 9.34886 6.33838 9.625 6.33838C9.90114 6.33838 10.125 6.11453 10.125 5.83838H9.125ZM6.875 5.83838V5.625H5.875V5.83838H6.875ZM9.125 5.625V5.83838H10.125V5.625H9.125ZM8 4.5C8.62132 4.5 9.125 5.00368 9.125 5.625H10.125C10.125 4.4514 9.17361 3.5 8 3.5V4.5ZM6.875 5.625C6.875 5.00368 7.37868 4.5 8 4.5V3.5C6.8264 3.5 5.875 4.4514 5.875 5.625H6.875Z",
    fill: "#ED7E00"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuitecaseSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/suitecase-small.c92b0407.svg";
export { ForwardRef as ReactComponent };